<template>
  <ion-page>
    <ion-content>
      <div class="spinner">
        <ion-spinner name="dots" />
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, IonSpinner } from '@ionic/vue';
export default {
  components: {
    IonPage,
    IonContent,
    IonSpinner,
  },
};
</script>

<style scoped>
.spinner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
